<div class="upcoming-activity">
  <div class="upcoming-activity__header">
    <h3 class="upcoming-activity__title">{{ title | transloco }}</h3>
    <button class="upcoming-activity__see-more-btn" (click)="onSeeMore()">{{ 'maintenanceDashboard.seeMore' | transloco }}</button>
  </div>

  @if (isLoading && page === 1) {
    <div class="upcoming-activity__loading">
      <span class="spinner-border"></span>
    </div>
  } @else if (activities.length === 0) {
    <div class="upcoming-activity__empty">
      <app-empty-state [message]="'maintenanceDashboard.noUpcomingActivities' | transloco"></app-empty-state>
    </div>
  } @else {
    <div
      class="upcoming-activity__list"
      infiniteScroll
      [scrollWindow]="false"
      (scrolled)="onScrollDown()"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="300">
      @for (activity of activities; track activity.workOrderId) {
        <div class="activity-card" (click)="onActivityClick()">
          <div class="activity-card__header">
            <div class="activity-card__info">
              <span class="activity-card__asset-id" [title]="activity.assetName">{{ activity.assetName }}</span>
              <span class="activity-card__date">{{ activity.scheduledDate ? (activity.scheduledDate | date: 'dd/MM/yyyy') : '-' }}</span>
            </div>
            <button
              class="activity-card__assign-btn"
              [class.activity-card__assign-btn--assigned]="activity.technician"
              [title]="activity.technician"
              (click)="onAssign(activity, $event)">
              {{ activity.technician || ('common.assign' | transloco) }}
            </button>
          </div>
          <div class="activity-card__maintenance-type" [ngClass]="getMaintenanceTypeClass(activity.maintenanceReason)">
            {{ activity.localizedMaintenanceReason || activity.maintenanceReason }}
          </div>
        </div>
      }

      @if (isLoading && page > 1) {
        <div class="upcoming-activity__loading-more">
          <span class="spinner-border spinner-border-sm"></span>
        </div>
      }
    </div>
  }
</div>